export const LogoImage = ({ className = "h-8 w-auto", variant = "dark" }) => (
  <img
    src={variant === "light" ? "/logo-light.png" : "/logo.png"}
    alt="Arrow Locksmith"
    className={className}
  />
);
